module.exports = __webpack_public_path__ + "static/img/开盘-1.a8144e75.png";